/**
 * Utility functions for authentication-related operations
 */

/**
 * Clears all Okta-related tokens from localStorage
 * This ensures consistent token cleanup across the application
 */
export const clearOktaTokens = (): void => {
  try {
    // Clear all Okta-related localStorage items
    localStorage.removeItem('okta-token-storage')
    localStorage.removeItem('okta-cache-storage')
    localStorage.removeItem('okta-shared-transaction-storage')
    localStorage.removeItem('okta-original-uri-storage')
    localStorage.removeItem('okta-pkce-storage')
    localStorage.removeItem('okta-transaction-storage')

    // Clear any session storage items that might be related
    sessionStorage.removeItem('okta-token-storage')
    sessionStorage.removeItem('okta-cache-storage')

    // Clear any cookies that might be related to authentication
    // This helps prevent automatic re-login
    document.cookie.split(';').forEach(cookie => {
      const [name] = cookie.trim().split('=')
      if (name.includes('okta') || name.includes('auth') || name.includes('JSESSION')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
      }
    })

    console.log('All Okta tokens and cookies cleared')
  } catch (error) {
    // Continue even if token clearing fails
    console.warn('Failed to clear Okta tokens:', error)
  }
}

/**
 * Clears all authentication-related data from localStorage
 * This is a more comprehensive cleanup that includes backend tokens
 */
export const clearAllAuthData = (): void => {
  try {
    // Clear Okta tokens
    clearOktaTokens()

    // Clear backend tokens
    localStorage.removeItem('access_token')
    localStorage.removeItem('auth-code')
  } catch (error) {
    // Continue even if clearing fails
    console.warn('Failed to clear auth data:', error)
  }
}
